export enum AccessPermission {
	PARTIAL = 'PARTIAL',
	TOTAL = 'TOTAL',
}
